import {ComponentType, CSSProperties, MouseEventHandler, ReactNode, SVGProps, useState} from 'react';
import {DfbInformationSymbol} from '../symbol/Symbol';
import Tooltip, {TooltipProps} from './Tooltip';

export type TooltipIconButtonProps = {
    style?: CSSProperties,
    onClick?: MouseEventHandler<HTMLDivElement>,
    icon?: ComponentType<SVGProps<SVGSVGElement>>,
    iconProps?: SVGProps<SVGSVGElement>,
    tooltip?: TooltipProps,
    tooltipChildren?: ReactNode
}

const TooltipIconButton = (props: TooltipIconButtonProps) => {
    const [tooltipVisible, setTooltipVisible] = useState(false);
    const [buttonEl, setReferenceElement] = useState<HTMLElement | null>(null);

    return (
        <div className="dfb-IconButton" style={props.style} onClick={props.onClick}>
            {
                props.tooltip &&
                <Tooltip {...props.tooltip} root={buttonEl} isVisible={tooltipVisible} setVisible={setTooltipVisible}>
                    {props.tooltipChildren}
                </Tooltip>
            }
            <span className="dfb-Icon dfb-IconButton-icon" ref={setReferenceElement} onClick={() => setTooltipVisible(!tooltipVisible)}>
                <props.icon {...props.iconProps}/>
            </span>
            <span className="dfb-IconButton-label">IconButton</span>
        </div>
    );
};

TooltipIconButton.defaultProps = {
    icon: DfbInformationSymbol
};

export default TooltipIconButton;
